import React from "react";
import { ThemeProvider } from "styled-components";
import { useTranslation } from "react-i18next";
import GlobalStyles from "../Global";

const theme = {
  colors: {
    txt: {
      color0: "#383838",
      color1: "#5c0630", // Menu link
      color2: "#38041d", // Menu link active
      color4: "#caa037", // Menu link hover
      color5: "#d3d3d3",
      color6: "#fff", // Button
    },
    bg: {
      color0: "#e6e6e6", // Submenu
      color1: "#5c0630", // Button
      color2: "#38041d", // Button hover
      color3: "#caa037",
    },
    color4: "#b6bf00",
    colorbg0: "#ffffff",
    colortxt0: "#4e4e4e",
    colortxt1: "rgba(28,64,68,var(--tw-text-opacity))",
    colorbgerror: "#e7938495",
    colorbgsuccess: "#e0e78494",
    colortxt: "#383838",
    colortxthover: "#000000",
    colortxtlighthover: "#e6e6e6",
  },

  size: {
    xs: "375px",
    sm: "596px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
  },
};

const Theme = ({ children }) => {
  const { i18n } = useTranslation(); // Access current language

  return (
    <ThemeProvider theme={theme}>
      <>
        {/* Pass current language to GlobalStyles for font & direction */}
        <GlobalStyles lang={i18n.language} />
        {children}
      </>
    </ThemeProvider>
  );
};

export default Theme;